module["exports"] = [
  "#{last_name} #{first_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ko/name/name.js
 ** module id = 823
 ** module chunks = 0
 **/